import React, {Component} from 'react';
import { FormattedMessage } from 'react-intl';
import ReactSVG from 'react-svg';
import Button from './../../components/button/Button'
import styles from './TermsConditionsScreen.module.css';

import CloseIcon from './../../assets/img/close-icon.svg';

class TermsConditionsScreen extends Component {

    constructor(props) {
        super(props);
        this.state = {
            topbarAnimation: "hidden",
            pageTransitionEnd: false
        }

        document.body.classList.remove("purpleBackground");

        this.animationEnd = this.animationEnd.bind(this);
        this.backToLogin = this.backToLogin.bind(this);
    }

    componentDidMount(props){
        window.onscroll = function(){
            if(window.pageYOffset >= 50 && this.state.topbarAnimation !== "open"){
                this.setState({
                    topbarAnimation: "open"
                });
            }
            if(window.pageYOffset < 50 && this.state.topbarAnimation === "open"){
                this.setState({
                    topbarAnimation: "close"
                });
            }
        }.bind(this);
    }

    backToLogin() {
        this.props.history.goBack();
    }

    animationEnd() {
        this.setState({
            pageTransitionEnd: true
        });
    }

    render() {
        let topbarAnimation, animation = "";
        if(!this.state.pageTransitionEnd){
            animation = " animated slideInUp";
        }
        if(this.state.topbarAnimation === "open"){
            topbarAnimation = "animated slideInDown";
        }
        if(this.state.topbarAnimation === "close"){
            topbarAnimation = "animated slideOutUp";
        }
        if(this.state.topbarAnimation === "hidden"){
            topbarAnimation = styles.hidden;
        }

        return (
            <div className={"page"}>
                <div className={[styles.header, topbarAnimation].join(' ')}>
                    <div className={styles.titleContainer}>
                        <h4 className="h4Bold"><FormattedMessage id="termsAndConditions" /></h4>
                    </div>
                </div>
                <ReactSVG src={CloseIcon} onClick={this.backToLogin} className={styles.closeButton} />
                <div className={animation} onAnimationEnd={this.animationEnd}>
                    <div className={styles.termsSection}>
                        <h3><FormattedMessage id="termsAndConditions" /></h3>
                        <p><FormattedMessage id="termsAndConditionsText" /></p>
                    </div>
                </div>
            </div>
        );
    }

}

export default TermsConditionsScreen;